<template>
  <div id="app">
    <van-nav-bar
      v-if="isShowBar"
      :title="myTitle"
      @click-left="goLeft"
      left-text="返回"
      left-arrow
    >
    </van-nav-bar>
    <div v-if="isShowBar" class="app_nav_magin"></div>
    <div class="app_main_content">
      <!-- <transition :name="transitionName">
        <keep-alive>
          <router-view
            :include="routerKeepArr"
            class="transitionBody"
          ></router-view>
        </keep-alive>
      </transition> -->

        <router-view
          v-if="!$route.meta.keepAlive"
        ></router-view>
        <keep-alive>
          <router-view
            v-if="$route.meta.keepAlive"
          ></router-view>
        </keep-alive>
    </div>
  </div>
</template>

<script>
import { NavBar } from "vant";
import { getConfig } from "@/utils/logClientType";
import router from "./router";

export default {
  name: "App",
  data() {
    return {
      isShowBar: false,
      loginType: 1,
      myTitle: "",
      transitionName: ""
    };
  },
  watch: {
    //监听页面的index变化来设置动画效果
    $route(to, from) {
      // debugger
      // const fromIndex = from.meta.index || 999;
      // const toIndex = to.meta.index || 999;
      // if (toIndex < fromIndex) {
      //   this.transitionName = "transitionRight";
      // } else if (toIndex > fromIndex) {
      //   this.transitionName = "transitionLeft";
      // } else if (toIndex == fromIndex) {
      //   this.transitionName = "";
      // }
    }
  },
  computed: {
    routerKeepArr() {
      let arr = [];
      router.options.routes.forEach(item => {
        if (item.meta && item.meta.keepAlive) {
          arr.push(item.name);
        }
      });
      console.log(arr);
      return arr;
    }
  },
  created() {
    this.loginType = getConfig();
  },
  beforeUpdate() {
    this.loginType = getConfig();
    this.myTitle = this.$route.meta.title;
    this.isShowBar = false;
    if (this.loginType === 5) {
      if (!this.$route.meta.isNotShowBar) {
        this.isShowBar = true;
      }
    }
  },
  methods: {
    goLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
#app {
  color: #323233;
  height: 100%;
}
.transitionBody {
  transition: all 0.4s ease;
}

.transitionLeft-enter,
.transitionRight-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
  transform: translate3d(100%, 0, 0);
}

.transitionLeft-leave-active,
.transitionRight-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}

.transitionLeft-enter-active,
.transitionRight-enter-active {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue